import { useEffect, useRef, useState } from "react";
import { supabase } from "../supabaseClient";

export function useAtividades(entityType, entityId) {
  const [atividades, setAtividades] = useState([]);
  const [perfisAtiv, setPerfisAtiv] = useState({});
  const cache = useRef({});

  const buscarPerfis = async (ids) => {
    const novos = [...new Set(ids)].filter((id) => id && !cache.current[id]);
    if (!novos.length) return;
    const { data } = await supabase.from("profiles").select("id, nome, nickname").in("id", novos);
    (data || []).forEach((p) => { cache.current[p.id] = p; });
    setPerfisAtiv({ ...cache.current });
  };

  useEffect(() => {
    setAtividades([]);
    if (!entityId || entityType !== "project") return;
    let ativo = true;

    supabase
      .from("project_atividades")
      .select("id, user_id, tipo_acao, entidade, entidade_id, nome_item, created_at")
      .eq("project_id", entityId)
      .order("created_at", { ascending: false })
      .limit(30)
      .then(async ({ data }) => {
        if (!ativo) return;
        const lista = data || [];
        await buscarPerfis(lista.map((a) => a.user_id));
        if (ativo) setAtividades(lista);
      });

    const canal = supabase
      .channel(`ativ:${entityId}`)
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table: "project_atividades", filter: `project_id=eq.${entityId}` },
        async (p) => {
          await buscarPerfis([p.new.user_id]);
          setAtividades((l) => [p.new, ...l].slice(0, 30));
        }
      )
      .subscribe();

    return () => { ativo = false; supabase.removeChannel(canal); };
  }, [entityType, entityId]);

  return { atividades, perfisAtiv };
}